const angular = require('angular');

const { pickupWizardComponentDefinition } = require('./pickup-wizard.component');
const { pickUpAddressSelectorComponentDefinition } = require('./pickup-selector-v2.component');

angular.module('wowApp.fulfilment')
    .component('wowPickupWizard', pickupWizardComponentDefinition)
    .component('wowPickupAddressSelectorV2', pickUpAddressSelectorComponentDefinition);



// WEBPACK FOOTER //
// ./src/fulfilment/pickup/index.js